import {injectable} from '@123/druid/dist/Framework/Decorators/Inject';
import ShoppingCartService from '@Component/ShoppingCart/Service/ShoppingCartService';
import type {AddProductRequest} from '@Component/ShoppingCart/Type/ShoppingCartRequest';
import type {AddProductResponse} from '@Component/ShoppingCart/Type/ShoppingCartResponse';
import EventHub from '@Service/LegacyBridge/EventHub/EventHub';

@injectable()
export default class ShoppingCart {
    constructor(private readonly service: ShoppingCartService = new ShoppingCartService()) {}

    public addProduct(product: AddProductRequest): Promise<AddProductResponse> {
        return new Promise((resolve, reject) => {
            this.service
                .addProduct(product)
                .then((response: AddProductResponse) => {
                    EventHub.instance.trigger('ShoppingCartProductAdded', {event: null, response});
                    EventHub.instance.trigger('Product.added-to-cart.no-recommendation');
                    EventHub.instance.trigger('Product.added-to-cart');
                    resolve(response);
                })
                .catch((err: Error) => {
                    reject(err);
                });
        });
    }
}
